// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"72bdd0ae","488":"72bdd0ae"}[chunkId] + ".chunk.css";
};